import { PAYMENT_TERM_KINDS, paymentSchedule, paymentTermLabels, type PaymentTerms } from "@rutamagica/contracts";
import { Field, SelectField } from "../../components/ui";
import { formatDate, mexicoDateKey } from "../../data/format";
import { money } from "./shared";

/** How the customer pays: reservation fee, advance, on the day or all now, with the resulting amounts. */
export function PaymentTermsFields({ terms, total, serviceDate, onChange }: {
  terms: PaymentTerms;
  total: number;
  serviceDate?: string | undefined;
  onChange: (terms: PaymentTerms) => void;
}) {
  const schedule = paymentSchedule(terms, total, serviceDate);
  const needsAmount = terms.kind === "reservation_fee" || terms.kind === "advance";
  const hasRest = terms.kind === "reservation_fee" || terms.kind === "advance";
  return (
    <section className="payment-terms" aria-label="Cómo se paga">
      <h3>Cómo se paga</h3>
      <div className="quote-form-grid quote-form-grid--dense">
        <SelectField className="span-10" label="Forma de pago" value={terms.kind} onChange={(e) => onChange({ ...terms, kind: e.target.value as PaymentTerms["kind"] })}>
          {PAYMENT_TERM_KINDS.map((kind) => <option key={kind} value={kind}>{paymentTermLabels[kind]}</option>)}
        </SelectField>
        {needsAmount && (
          <Field
            className="span-6"
            label={terms.kind === "reservation_fee" ? "Monto del apartado" : "Anticipo"}
            type="number"
            min="0"
            step="1"
            value={terms.upfront > 0 ? terms.upfront : ""}
            placeholder="0"
            onChange={(e) => onChange({ ...terms, upfront: e.target.value === "" ? 0 : Number(e.target.value) })}
          />
        )}
        {hasRest && (
          <SelectField className="span-8" label="El resto se paga" value={terms.balance_due} onChange={(e) => onChange({ ...terms, balance_due: e.target.value as PaymentTerms["balance_due"] })}>
            <option value="service_day">El día del servicio</option>
            <option value="day_before">Un día antes (obligatorio)</option>
          </SelectField>
        )}
      </div>
      {total > 0 && (
        <p className="payment-terms__summary" role="status">
          {schedule.upfront > 0 && <span>Ahora: <strong>{money(schedule.upfront, "MXN")}</strong>{terms.kind === "reservation_fee" ? " (apartado, no reembolsable)" : ""}</span>}
          {schedule.dueDate && schedule.dayBefore && schedule.dueDate < mexicoDateKey() && <span className="text-danger">Un día antes ya pasó: elige "El día del servicio".</span>}
          {schedule.rest > 0 && <span>{terms.kind !== "on_service_day" ? "Resto" : "Total del servicio"}: <strong>{money(schedule.rest, "MXN")}</strong>{schedule.dueDate ? ` · ${schedule.dayBefore ? "a más tardar el" : "el"} ${formatDate(schedule.dueDate)}` : schedule.dayBefore ? " · un día antes del servicio" : " · el día del servicio"}</span>}
        </p>
      )}
    </section>
  );
}
